<template lang="pug">
	div
		buscador(:form="filtro" @nuevo="nuevoRecibo()" :resultados="resultados" @buscar="buscar()" @descargar="descargar($event)")
		listado-resultados(:resultados="resultados" @ver="editar($event)" @eliminar="elimina($event)")
		editor(v-if="idRecibo" :id-recibo="idRecibo" @cerrar="idRecibo = null" @actualizar="buscar()")
</template>

<script>
import Resultados from './resultados'
import Buscador from './buscador'
import Editor from './editor-nuevo'
import API from '../../services/api.js'
import { mapGetters } from 'vuex'

export default {
	components: {
		'listado-resultados': Resultados,
		'buscador': Buscador,
		'editor': Editor
	},
	data () {
		return {
			filtro: {
				AgenteNombre: null,
				ClienteNombre: null,
				FechaIni: null,
				FechaFin: new Date(),
				ordenarPor: null,
				ordenarDir: null,
				estado: 'Pendiente'
			},
			resultados: [],
			idRecibo: null,
			verEditor: false
		}
	},

	computed: {
		...mapGetters({
			permisos: ['permisos/permisos']
		})
	},

	methods: {
		buscar () {
			if (this.filtro.FechaIni) {
				this.filtro.FechaIni.setDate(1)
				this.filtro.FechaIni.setHours(0)
				this.filtro.FechaIni.setMinutes(0)
				this.filtro.FechaIni.setSeconds(0)
				this.filtro.FechaIni.setMilliseconds(0)
			}

			if (this.filtro.FechaFin) {
				this.filtro.FechaFin.setDate(1)
				this.filtro.FechaFin.setHours(23)
				this.filtro.FechaFin.setMinutes(59)
				this.filtro.FechaFin.setSeconds(59)
				this.filtro.FechaFin.setMilliseconds(0)

				this.filtro.FechaFin.setMonth(this.filtro.FechaFin.getMonth() + 1)
				this.filtro.FechaFin.setDate(0)
			}
			API.buscar(this.filtro)
				.then(res => {
					this.resultados = res.data
				})
				.catch(e => {
					this.$store.commit('alertas/alert', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		descargar (tipo) {
			API.buscar(this.filtro, tipo)
				.then(res => {
					const texto = res.data

					const element = document.createElement('a')
					switch (tipo) {
					case 'csv':
						element.setAttribute('href', 'data:text/x-csv;charset=utf-8,' + encodeURIComponent(texto))
						element.setAttribute('download', 'cobros.csv')
						break
					case 'xls':
						element.setAttribute('href', 'data:application/octet-stream;charset=utf-8,' + encodeURIComponent(texto))
						element.setAttribute('download', 'cobros.xlsx')
						break
					}

					element.style.display = 'none'
					document.body.appendChild(element)

					element.click()

					document.body.removeChild(element)
				})
				.catch(e => {
					console.error(e)
				})
		},
		nuevoRecibo () {
			this.idRecibo = 'nuevo'
		},

		editar (recibo) {
			this.idRecibo = recibo.ReciboID
		},

		elimina (recibo) {
			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar recibo',
				mensaje: '¿Estás seguro de que quieres eliminar este recibo?\n\nEsta acción no se podrá deshacer',
				callback: (acepta) => {
					if (!acepta) {
						return
					}

					API.eliminar(recibo.ReciboID)
						.then(res => {
							this.buscar()
						})
						.catch(e => {
							this.$store.commit('alertas/alert', {
								titulo: 'Error',
								mensaje: e.response.data.error
							})
						})
				}
			})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/facturacion-cobros/vue/components/cobros/index.vue